import { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { ProductDetail } from "@interfaces/dto/product-detail.dto";
import ProductConfiguration from "../product-detail/info/ProductConfiguration";
import AddButtonSet from "../product-detail/info/AddButtonSet";
import { useRouter } from "next/router";
import AddtoCartNavigate from "./AddtoCartNavigate";
import { numberToMoneyString } from "@utils/numbers.util";
import { PRODUCT_NOT_FOUND_IMG } from "@const/products.const";

type Props = {
  selectedVarientSku: any;
  isConfigurable: boolean;
  handleSelectedVarientChanged: (sku: string) => void;
  productDetail: ProductDetail;
  productselectedQty: number;
  handleProductselectedQtyChanged: (qty: number) => void;
  handleAddtoCart: (qty: number) => Promise<void>;
  isWishlist: boolean;
  onUpdateWishList: (isWishlist: boolean) => void;
  isAddtoCartLoading: boolean;
  isSaleable: boolean;
  isWishlistLoading: boolean;
  isShowCanvas: boolean;
  handleShowCanvas: () => void;
  handleCloseCanvas: () => void;
  fixPriceValue: number;
  specialPriceValue: number;
  imageUrl: string | null;
};

const ProductViewNavigate = ({
  selectedVarientSku,
  isConfigurable,
  handleSelectedVarientChanged,
  productDetail,
  productselectedQty,
  handleProductselectedQtyChanged,
  handleAddtoCart,
  isWishlist,
  onUpdateWishList,
  isAddtoCartLoading,
  isSaleable,
  isWishlistLoading,
  isShowCanvas,
  handleShowCanvas,
  handleCloseCanvas,
  fixPriceValue,
  specialPriceValue,
  imageUrl,
}: Props) => {
  const router = useRouter();
  return (
    <>
      {/* OffCanvas */}
      <Offcanvas
        show={isShowCanvas}
        onHide={handleCloseCanvas}
        placement="bottom"
        responsive="lg"
        className="border border-light rounded-top border-start-0 border-end-0 border-bottom-0 border-light h-auto d-block d-lg-none"
      >
        <Offcanvas.Header closeButton className="pb-0 pt-2 ">
          <Offcanvas.Title></Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="info">
            <div className="row g-2">
              <div className="col-2">
                {" "}
                <img
                  src={imageUrl ? imageUrl : PRODUCT_NOT_FOUND_IMG}
                  alt={productDetail.name}
                  className="img-fluid border border-1"
                />
              </div>
              <div className="col">
                <p>{productDetail.name}</p>
                {isConfigurable ? (
                  <>
                    <p className="text-red fw-bold fs-5">
                      ฿{numberToMoneyString(specialPriceValue, 0)}.-
                    </p>
                  </>
                ) : (
                  <div className="product-price">
                    <span className="text-red fw-bold fs-5">
                      ฿{numberToMoneyString(productDetail.special_price, 0)}.-
                    </span>
                    <small className="text-decoration-line-through text-muted ps-2 fs-6">
                      ฿{numberToMoneyString(productDetail.price, 0)}.-
                    </small>
                  </div>
                )}
              </div>
            </div>
          </div>

          {isConfigurable ? (
            <div className="text-start mt-0 mt-sm-3">
              <p>{productDetail.customizes[0].title}</p>
              <div className="product-color-switch d-flex align-content-start flex-wrap">
                {productDetail.customizes[0].values.map((varient, key) => (
                  <div key={key} className="mb-1">
                    <ProductConfiguration
                      varient={varient}
                      selectedVarientSku={selectedVarientSku}
                      isChecked={
                        varient.sku === selectedVarientSku ? true : false
                      }
                      onSelectedVarientChange={handleSelectedVarientChanged}
                    />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            ""
          )}

          <div className="mt-1 text-center">
            <AddButtonSet
              selectedQty={productselectedQty}
              onQtyChange={handleProductselectedQtyChanged}
              onAddtoCart={handleAddtoCart}
              isWishlist={isWishlist}
              onUpdateWishList={onUpdateWishList}
              isLoading={isAddtoCartLoading}
              isSaleable={isSaleable}
              isWishlistLoading={isWishlistLoading}
            />
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <AddtoCartNavigate
        handleShowCanvas={handleShowCanvas}
        isSaleable={isSaleable}
        isLoading={isAddtoCartLoading}
        isWishlist={isWishlist}
        onUpdateWishList={onUpdateWishList}
      />
    </>
  );
};

export default ProductViewNavigate;
